import type { ElevarEvent } from 'types'
import { segment } from '../segment'
import { waitForCartUpdate } from '../utils/cart-utils'
import { buildSegmentPayload } from '../utils/segment-payload-builder'
import { getCart } from '../../resources/shopify-cart'

export const productAddedTransformer = async (item: ElevarEvent) => {
  try {
    const variantId = item.ecommerce?.add?.products?.[0]?.variant_id
    const cart = variantId
      ? await waitForCartUpdate(variantId)
      : await getCart()

    if (!cart) return item

    const product = item.ecommerce?.add?.products?.[0]
    if (!product) return item

    const segmentPayload = buildSegmentPayload(cart, product)
    segment.track('Product Added', segmentPayload)
    return item
  } catch (error) {
    console.error('Error in productAddedTransformer:', error)
    return item
  }
}
